import React, { useEffect, useMemo, useRef } from "react";
import { useSelector } from "react-redux";
import { NavLink, useLocation, useNavigate, useParams } from "react-router-dom";
import { routeMapping } from "../GameTypeSelector/utils/routeMapping";
import { Splide, SplideSlide, SplideTrack } from "@splidejs/react-splide";
import {
  AbsoluteCenter,
  Box,
  Flex,
  Icon,
  Image,
  Link,
  Text,
  chakra,
  shouldForwardProp,
  useColorMode,
  useColorModeValue,
} from "@chakra-ui/react";
import { COMMON_WEB_PATH } from "../../../constant";
import { thisImageNeedDark } from "../../../utils/thisImageNeedDark";
import { useTranslation } from "react-i18next";
import { gameListFromBottom } from "../../../animateConstant";
import { isValidMotionProp, motion } from "framer-motion";
import useSound from "../../../hook/useSound";

const ChakraBox = chakra(motion.div, {
  shouldForwardProp: (prop) =>
    isValidMotionProp(prop) || shouldForwardProp(prop),
});

const gradientStyle = {
  color: "white",
  WebkitTextStroke: "0.5px #804ed2",
  textStroke: "0.5px #804ed2",
  textShadow: `
  -1px -1px 0 #804ed2,  
   1px -1px 0 #804ed2,
  -1px 1px 0 #804ed2,
   1px 1px 0 #804ed2
`,

  display: "inline-block",
};
const PlatformSelectorMobile = ({ gameMainTypeFromProps, direction }) => {
  const { t } = useTranslation();
  const i18n = (key) => t(`common.${key}`);
  const isHandleAllGame = useSelector((state) => state.isHandleAllGame);

  const boxBg = useColorModeValue("#E9E8F2", "#394367");
  const textColor = useColorModeValue("#757576", "#E9E8F2");

  const { colorMode, toggleColorMode } = useColorMode();

  const { gameList } = isHandleAllGame || {};

  const scrollRef = useRef();
  const splideRef = useRef();

  const navigate = useNavigate();
  const location = useLocation();

  const { pathname } = location;

  //   const getGameType = useMemo(() => {
  //     return pathname.split("/")[1];
  //   }, [pathname]);
  const { gameMainType, gamePlatform } = useParams(); // 獲取路由參數
  const playButtonSound = useSound();
  const hoverButtonSound = useSound({
    customSound: "slide_sound",
    volume: 0.3,
  });

  const getPlatform = useMemo(() => {
    const mainType = gameMainTypeFromProps || gameMainType;
    if (gameList) {
      // 通過routeMapping轉換遊戲類型
      const current_game_type = routeMapping(mainType)?.origin;
      return {
        // 獲取該遊戲類型下所有平台
        platform_list: Object?.keys(gameList[current_game_type] || {}),
      };
    }
  }, [gameList, gameMainType, gameMainTypeFromProps]);
  const platformList = useMemo(() => {
    const mainType = gameMainTypeFromProps || gameMainType;
    const { platform_list } = getPlatform || {};
    const current_game_type = routeMapping(mainType)?.origin;

    return platform_list?.map((item) => {
      // 獲取每個平台的遊戲數量
      const game_length = gameList?.[current_game_type]?.[item]?.length;
      return (
        <SplideSlide key={item}>
          <Link
            as={NavLink}
            to={`/${mainType}/category/${item}/AllGames`}
            h={
              direction
                ? "100px"
                : {
                    base: "50px",
                    md: "65px",
                  }
            }
            _hover={{
              textDecoration: "none",
            }}
            onMouseEnter={hoverButtonSound}
            onClick={playButtonSound}
          >
            {({ isActive }) => {
              return (
                <Box position={"relative"}>
                  <Box role="group">
                    <Flex
                      h={{
                        base: "85px",
                      }}
                      justifyContent={`center`}
                      gap="2.5px"
                      //direction="column"
                      alignItems={`center`}
                      // bg={isActive ? "brand.500" : boxBg}

                      cursor="pointer"
                      bgPosition="center"
                      bgRepeat="no-repeat"
                      bgSize={"120%100%"}
                      borderRadius={{
                        base: "0px",
                        md: "15px",
                      }}
                      position={`relative`}
                      py="10px"
                      px={{
                        base: "10px",
                        md: "20px",
                      }}
                      _after={{
                        content: "''",
                        position: "absolute",
                        right: "-7px",
                        bottom: "0px",
                        width: "3px",
                        height: "100%",
                        bgImage: `url('${COMMON_WEB_PATH}/theOne/gameType/platform_split_line.png')`,
                        bgSize: "contain",
                        bgPos: "center",
                      }}
                    >
                      <Box
                        _groupHover={{
                          display: "block",
                        }}
                        display={isActive ? "block" : "none"}
                        bgImage={`url('${COMMON_WEB_PATH}/theOne/gameType/platform_active_mobile.png')`}
                        position={"absolute"}
                        top="0"
                        left="0"
                        w="100%"
                        bgSize="100%100%"
                        bgRepeat="no-repeat"
                        bgPos="center"
                        h="100%"
                      ></Box>
                      <Image
                        w={{
                          base: "100%",
                          md: "60%",
                        }}
                        objectFit="cover"
                        position="relative"
                        zIndex="1"
                        src={`${COMMON_WEB_PATH}/ds88platformIcon/${thisImageNeedDark(
                          item.replace(/\s+/g, ""), // 移除所有空格
                          true
                        )}.png`}
                        alt={item}
                      />
                    </Flex>
                  </Box>
                  {/* <Box
                    position="absolute"
                    top="50%"
                    right="-9px"
                    transform={"translate(-50%, -50%)"}
                    w="10px"
                    h="80%"
                    bgImage={`url('${COMMON_WEB_PATH}/5285/platform_list/platform_list_border_blue.png')`}
                    bgSize="100% 100%"
                  ></Box> */}
                </Box>
              );
            }}
          </Link>
        </SplideSlide>
      );
    });
  }, [
    getPlatform,
    gameList,
    gameMainTypeFromProps,
    boxBg,
    textColor,
    direction,
  ]);

  useEffect(() => {
    const { platform_list } = getPlatform || {};

    if (splideRef.current) {
      const splide = splideRef.current.splide;

      splide.go(platform_list?.indexOf(gamePlatform));
    }
  }, [getPlatform, gamePlatform]);

  return (
    <>
      <Box
        // ref={scrollRef}
        //px="40px"
        w="100%"
        mx="auto"
        // overflowY={"scroll"}
        h={"80%"}
        position="relative"
      >
        <Box
          position="absolute"
          top="50%"
          left="50%"
          transform="translate(-50%, -50%)"
          w="100%"
          h="100%"
          bgColor="rgba(0,0,0,0.68)"
          borderRadius={"15px"}
          border="1px solid #FDE2D4"
        ></Box>
        <ChakraBox
          key={gameMainTypeFromProps || gameMainType}
          {...gameListFromBottom}
          position="relative"
          h="100%"
        >
          <Splide
            hasTrack={false}
            ref={splideRef}
            className="z-[3] !h-full px-[10px]"
            options={{
              // wheel: true, // 啟用滾輪滾動
              pagination: false,
              arrows: true,
              drag: "free",
              direction: "ltr",
              // fixedWidth: "100%",
              fixedWidth: "80px",
              fixedHeight: "85px", // 每個項目的固定高度
              height: "100%", // 根據方向設定高度
              gap: direction === "col" ? "10px" : "8px", // 項目之間的間距
            }}
          >
            <Box className="splide__arrows">
              <button
                className="splide__arrow splide__arrow--prev"
                style={{
                  background: "none",
                  width: "30px",
                  height: "30px",
                }}
              >
                <Image src={`${COMMON_WEB_PATH}/theOne/menu_arrow_right.png`} />
              </button>
              <button
                className="splide__arrow splide__arrow--next"
                style={{
                  background: "none",
                  width: "30px",
                  height: "30px",
                }}
              >
                <Image src={`${COMMON_WEB_PATH}/theOne/menu_arrow_left.png`} />
              </button>
            </Box>
            <SplideTrack>{platformList}</SplideTrack>
          </Splide>
        </ChakraBox>
      </Box>
    </>
  );
};

export default PlatformSelectorMobile;
